<mat-card class="nsc-card"  [ngClass]="error ? 'system-message error' : ''"><ng-content></ng-content></mat-card>